export default __webpack_public_path__ + "static/ProblemSolving-1ce059e65a7d615b4a27bb4abbed02b0.mp4";